import React, { useState, useEffect } from 'react';
import Advertisement from './Advertisement';
import { useLocation } from 'react-router-dom';

interface AdContainerProps {
  location: 'masthead' | 'sidebar-left' | 'sidebar-right';
  className?: string;
}

// This would normally come from an API or context
const getAdsForLocation = (location: string, currentPage: string): Ad[] => {
  // Mock data - in a real app, this would be fetched from an API
  const allAds: Ad[] = [
    {
      id: '1',
      name: 'Kredi Kampanyası Banner',
      type: 'image',
      location: 'masthead',
      pages: ['ihtiyac-kredisi', 'konut-kredisi', 'tasit-kredisi'],
      imageUrl: 'https://images.unsplash.com/photo-1579621970795-87facc2f976d?auto=format&fit=crop&q=80&w=1200&h=200',
      linkUrl: 'https://example.com/kampanya',
      isActive: true,
      startDate: '2024-01-01',
      endDate: '2024-12-31',
      dimensions: '1200x200'
    },
    {
      id: '2',
      name: 'Mevduat Yan Banner',
      type: 'image',
      location: 'sidebar-right',
      pages: ['mevduat'],
      imageUrl: 'https://images.unsplash.com/photo-1565514020179-026b92b2d70b?auto=format&fit=crop&q=80&w=300&h=600',
      linkUrl: 'https://example.com/mevduat',
      isActive: true,
      startDate: '2024-01-01',
      endDate: '2024-12-31',
      dimensions: '300x600'
    },
    {
      id: '3',
      name: 'Kredi Kartı Sol Banner',
      type: 'image',
      location: 'sidebar-left',
      pages: ['kredi-kartlari'],
      imageUrl: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?auto=format&fit=crop&q=80&w=300&h=600',
      linkUrl: 'https://example.com/kredi-karti',
      isActive: true,
      startDate: '2024-01-01',
      endDate: '2024-12-31',
      dimensions: '300x600'
    }
  ];

  // Filter ads by location, active status, and current page
  return allAds.filter(ad => 
    ad.location === location && 
    ad.isActive && 
    ad.pages.includes(currentPage) &&
    new Date(ad.startDate) <= new Date() &&
    new Date(ad.endDate) >= new Date()
  );
};

const AdContainer: React.FC<AdContainerProps> = ({ location, className = '' }) => {
  const [availableAds, setAvailableAds] = useState<Ad[]>([]);
  const { pathname } = useLocation();
  
  // Get current page from pathname
  const currentPage = pathname === '/' ? 'home' : pathname.substring(1);

  useEffect(() => {
    // Check if there are ads for this location and page
    const ads = getAdsForLocation(location, currentPage);
    setAvailableAds(ads);
  }, [location, currentPage]);

  // If there are no ads for this location and page, don't render anything
  if (availableAds.length === 0) return null;
  
  let containerClass = '';
  
  switch (location) {
    case 'masthead':
      containerClass = 'w-full h-[200px] mb-6';
      break;
    case 'sidebar-left':
    case 'sidebar-right':
      containerClass = 'w-[300px] h-[600px] hidden lg:block sticky top-24';
      break;
  }
  
  return (
    <div className={`ad-container ${containerClass} ${className}`}>
      <Advertisement location={location} availableAds={availableAds} />
    </div>
  );
};

export default AdContainer;